import { useEffect, useState } from 'react'
import styles from './PurchaseFlatPage.module.css'
import { useFlat } from '../FlatCardPage/FlatContext'
import { useNavigate, useParams } from 'react-router-dom'
import { FLAT_PAGE, MAIN_PAGE } from '../../router/paths'
import InternalHeader from '../../components/InternalHeader/InternalHeader'
import BuyPageStageOne from './PurchaseFlatPageStages/PurchaseFlatPageStageOne/PurchaseFlatPageStageOne'
import BuyPageStageTwo from './PurchaseFlatPageStages/PurchaseFlatPageStageTwo/PurchaseFlatPageStageTwo'
import BuyPageStageThree from './PurchaseFlatPageStages/PurchaseFlatPageStageThree/PurchaseFlatPageStageThree'
import Loader from '../../components/Loader/Loader'
import { api } from '../../utils/api'
import { transformFlat } from '../../utils/transformers'
import { FlatCardData } from '../../components/CardsComponents/types'

export default function PurchaseFlatPage() {
  const navigate = useNavigate()
  const { id } = useParams()
  const { flat, setFlat, selectedOption } = useFlat()
  const [currentStage, setCurrentStage] = useState(0);
  const [resolvedFlat, setResolvedFlat] = useState<FlatCardData | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (flat) {
      setResolvedFlat(null);
      return;
    }

    const flatId = Number(id);
    if (!flatId || Number.isNaN(flatId)) {
      navigate(MAIN_PAGE);
      return;
    }

    let isCancelled = false;
    const loadFlat = async () => {
      try {
        setIsLoading(true);
        const response = await api.flats.getById(flatId);
        if (isCancelled || !response) return;

        const transformedFlat = transformFlat(response);
        setResolvedFlat(transformedFlat);
        setFlat(transformedFlat);
      } catch {
        if (!isCancelled) {
          navigate(MAIN_PAGE);
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    loadFlat();

    return () => {
      isCancelled = true;
    };
  }, [flat, id, navigate, setFlat])

  const stages = ['1', '2', '3'];
  const activeFlat = flat ?? resolvedFlat;

  const handleNextStage = () => {
    if (currentStage < stages.length - 1) {
      setCurrentStage(currentStage + 1);
    }
  };

  if (isLoading && !activeFlat) {
    return <Loader />;
  }

  if (!activeFlat) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <InternalHeader 
        title='Бронирование' 
        onClose={() => navigate(FLAT_PAGE.replace(':id', activeFlat.id.toString()))} 
        flatInfo={`${activeFlat.roomType} от ${activeFlat.area} м² на ${activeFlat.floor} этаже`}
      />
      
      <div className={styles.content_wrapper}>
        <div className={styles.content}>
          {currentStage === 0 && (
              <BuyPageStageOne
                  selectedOption={selectedOption}
                  flat={activeFlat}
                  handleNextStage={handleNextStage}
              />
          )}
          {currentStage === 1 && (
              <BuyPageStageTwo
                  handleNextStage={handleNextStage}
              />
          )}
          {currentStage === 2 && (
              <BuyPageStageThree />
          )}
        </div>
      </div>
    </div>
  )
}
